import { cn } from '@repo/videa-components/src/lib/utils';

export const BenchmarkChip = ({
  value,
  benchmark,
  isMicro = false,
  isHygiene = false,
}: {
  value?: number;
  benchmark: {
    lowerBenchmark?: number;
    upperBenchmark?: number;
  };
  isMicro?: boolean;
  isHygiene?: boolean;
}) => {
  if (value === undefined) {
    return null;
  }

  const lower = benchmark.lowerBenchmark ?? 0;
  const upper = benchmark.upperBenchmark ?? 0;
  const benchmarkValue =
    value < lower ? 'Low' : value < upper ? 'Medium' : 'High';

  if (isMicro) {
    return (
      <span
        className={cn('vai-inline-block vai-rounded-full vai-w-3 vai-h-3', {
          'vai-bg-chart-tint-1': benchmarkValue === 'Low' && !isHygiene,
          'vai-bg-chart-normal-1': benchmarkValue === 'Medium' && !isHygiene,
          'vai-bg-chart-shade-1': benchmarkValue === 'High' && !isHygiene,
          'vai-bg-zinc-100': benchmarkValue === 'Low' && isHygiene,
          'vai-bg-chart-normal-2': benchmarkValue === 'Medium' && isHygiene,
          'vai-bg-chart-shade-2': benchmarkValue === 'High' && isHygiene,
        })}
      />
    );
  }

  return (
    <span
      className={cn(
        'vai-flex vai-w-20 vai-items-center vai-justify-center vai-px-2 vai-py-1 vai-rounded-full vai-text-sm',
        {
          'vai-bg-chart-tint-1 vai-text-chart-shade-1':
            benchmarkValue === 'Low' && !isHygiene,
          'vai-bg-chart-normal-1 vai-text-white':
            benchmarkValue === 'Medium' && !isHygiene,
          'vai-bg-chart-shade-1 vai-text-white':
            benchmarkValue === 'High' && !isHygiene,
          'vai-bg-chart-tint-2 vai-text-chart-shade-2':
            benchmarkValue === 'Low' && isHygiene,
          'vai-bg-chart-normal-2 vai-text-white':
            benchmarkValue === 'Medium' && isHygiene,
          'vai-bg-chart-shade-2 vai-text-white':
            benchmarkValue === 'High' && isHygiene,
        },
      )}
    >
      {value < lower ? 'Low' : value < upper ? 'Medium' : 'High'}
    </span>
  );
};
